// extracted by mini-css-extract-plugin
export default {"titlePuls":"titleBarSB_titlePuls__MNAY1"};